export const SITE_AREAS = {
  OFFICE: 'office',
  ULTRA: 'ultra',
  GAMING: 'gaming',
  SPA: 'spa'
}
